var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details_content_repeat"},[_c('QS-h4-title',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"details_content_repeat_hundred"},[_c('el-form',{attrs:{"label-width":"200px"}},[_c('column-box',{attrs:{"source":_vm.source,"list":_vm.list,"labelWidth":_vm.labelWidth}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }